var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { ModalWithTitle } from '@/components/ui/Modal/ModalWithTitle';
import { HotlineTermsModalContent } from '@/feature/hotline/component/HotlineTermsModal/HotlineTermsModalContent';
import { hotlineTermsModalStyle } from '@/feature/hotline/component/HotlineTermsModal/style';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * 匿名ホットライン 利用規約同意モーダル
 */
export const HotlineTermsModal = (props) => {
    const { className = '', onSubmit } = props;
    const unmountRef = useUnmountRef();
    // モーダルの表示制御
    const { boolState: isShow, changeFalse: hideModal } = useBoolState({
        initialState: true,
    });
    /**
     * 送信処理
     */
    const onClickSubmitBase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmit();
        if (!unmountRef.current) {
            hideModal();
        }
    }), [onSubmit, unmountRef, hideModal]);
    // データ取得のローディング制御
    const { callbackPromiseEvent: onClickSubmit, doing: submitting } = usePromiseDoingCallback({
        initialDoingState: false,
        promiseEvent: onClickSubmitBase,
        unmountRef,
    });
    const style = hotlineTermsModalStyle();
    return (_jsx(ModalWithTitle, Object.assign({ className: style.base({ class: className }), contentClassName: style.contentWrap(), headText: '匿名コンサルホットラインの利用規約', isShow: isShow, maxWidth: 'max-w-[800px]' }, { children: _jsx(HotlineTermsModalContent, { onClickAgree: onClickSubmit, onClickDisagree: hideModal, submitting: submitting }) })));
};
